'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateSingleIcon = function TemplateSingleIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 23.91 19.74' }, props),
        _react2.default.createElement('path', { 'class': 'cls-1', d: 'M22 0H1.87A1.73 1.73 0 0 0 0 1.54v16.65a1.75 1.75 0 0 0 1.87 1.55H22a1.75 1.75 0 0 0 1.87-1.55V1.54A1.73 1.73 0 0 0 22 0zm1.12 18.19a1 1 0 0 1-1.12.93H1.87a1 1 0 0 1-1.12-.93V1.54A1 1 0 0 1 1.87.62H22a1 1 0 0 1 1.12.92z' }),
        _react2.default.createElement('path', { 'class': 'cls-1', d: 'M2.62 1.87a.73.73 0 0 0-.71.75v1.49h.75V2.62h1.82v-.75zM19.8 3.74H4.11a.36.36 0 0 0-.37.37v4.48a.37.37 0 0 0 .37.41H19.8a.37.37 0 0 0 .37-.38V4.11a.36.36 0 0 0-.37-.37zm-.37 4.48H4.48V4.48h15zM9.76 10.09H4.09a.35.35 0 0 0-.35.35v5.67a.35.35 0 0 0 .35.36h5.67a.35.35 0 0 0 .35-.36v-5.67a.35.35 0 0 0-.35-.35zm-5.32 5.67V11.3l4.47 4.46zm5-.5L5 10.8h4.41zM11.21 10.77h8.97v.75h-8.97zM12.7 12.51h7.56v.9H12.7zM11.64 14.96h1.02v1.02h-1.02zM13.68 14.96h1.02v1.02h-1.02z' })
    );
};

exports.default = TemplateSingleIcon;